import { useEffect } from "react";
import { Outlet } from "react-router";
import Header from "../Header";
import SideNav from "../SideNav";
import { ApiStatus } from "../../utils/apiStatus.enum";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Loader from "../Loader";
import Footer from "../Footer";

type LayoutProps = {
  updateTheme: (theme: "light" | "dark") => void;
};

const Layout = ({ updateTheme }: LayoutProps) => {
  useEffect(() => {
    updateTheme("dark");
  }, []);

  const userPermissionsStatus: ApiStatus = useSelector(
    (state: RootState) => state.UserProfileSlice.userPermissionsStatus,
  );

  if (userPermissionsStatus === ApiStatus.LOADING) {
    return (
      <div className="motif-theme-dark">
        <div
          className="motif-no-padding"
          style={{
            backgroundColor: "#0A0A14",
            minHeight: "100vh",
            margin: "0 auto",
            paddingTop: "20%",
          }}
        >
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className="motif-theme-dark">
      <Header />
      <div
        className="motif-no-padding"
        style={{
          backgroundColor: "lightgray",
          display: "flex",
          minHeight: "100vh",
          margin: "0",
          padding: "0",
        }}
      >
        <SideNav />
        <div
          style={{
            backgroundColor: "var(--body--bg-color)",
            flexGrow: "1",
            maxWidth: "calc(100% - 237px)",
          }}
        >
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
